import ViewDetailsButton from './ViewDetailsButton';

export default ViewDetailsButton;
